/**
 * Bundled English catalog re-exported from the shared/i18n package.
 *
 * Mirrors mobile/src/i18n/locales.ts. Two jobs:
 *   1. Acts as the bundled `en.json` fallback that Phase 0's runtime fetcher
 *      (web/src/i18n/init.ts, landing in a follow-up PR) will hand to
 *      i18next as the absolute last-resort resource set.
 *   2. Smoke-tests the `@newswave/i18n` path alias end-to-end — TypeScript
 *      (tsconfig paths) and Vite (resolve.alias + server.fs.allow) both have
 *      to resolve this import for `tsc -b --noEmit` and `vite build` to pass.
 */
import en from '@newswave/i18n/locales/en.json';

export const englishCatalog = en;
export type LocaleCatalog = typeof en;
